<template>
  <div :key="customerID">
    <b-card class="search">
      <h6 class="text-center">
        Showing Record from <span v-if="collection_.indexOf('.csv') == -1">database <strong style="color: #74b2cf">{{database_}}</strong> and table 
        <strong style="color: #74b2cf">{{get_collection_name(collection_)}}</strong></span> 
        <span v-else>file <strong style="color: #74b2cf">{{get_collection_name(collection_)}}</strong></span> with ID 
        <strong style="color: #74b2cf">{{customerID}}</strong>
      </h6>
      <b-button size="md" variant="primary" @click="search_for_record()">
       SEARCH OTHER RECORDS
      </b-button>
    </b-card>

    <div class="p-2">
      <customer-list-section
        active
        :filter="filter"
        :dataType="collection_"
        :database="database_"
        disable-download
        disable-sort
        v-if="!customerID"/>

      <template v-else>
        <customer-summary-view :id="customerID" :collection="collection_"/>
        <tab-view 
        :id="customerID"
        :database="database_"
        :collection="collection_"/>
      </template>
    </div>
  </div>
</template>

<script>
  import CustomerSummaryView from './CustomerSummaryView';
  import TabView from './TabView';
  import CustomerListSection from '../Insights/CustomerListSection';

  export default {
    name: 'Customer360',

    components: {
      CustomerSummaryView,
      TabView,
      CustomerListSection
    },

    watch: {
      "$route.params.id"(id) {
        this.customerID = id;
      },
      "$route.params.database"(db) {
        this.database_ = db;
      },
      "$route.params.collection"(col) {
        this.collection_ = col;
      }
    },

    data() {
      return {
        customerID: this.$route.params.id,
        database_: this.$route.params.database,
        collection_: this.$route.params.collection,
        filter: {
          method: "dynamic",
          values: {
            logic: "and",
            filters: []
          }
        }
      };
    },

    methods:{
      remove_underscore(x){
          return x.replace("_", " ").toUpperCase();
      },

      search_for_record() {
        this.$router.push(`/360`);
      },

      get_collection_name(collection) {
        var collection_name = collection;
        if (collection.indexOf('.csv') > -1) {
          this.$store.state.files.fileList.forEach(file => {
          // var col_name = this.getCollection(file);
          if (file.database === this.database_ && file._id === this.collection_) {
              collection_name = file.originalName;
            }
          });
        }
        return collection_name;
      }
    }

    
  };
</script>

<style scoped>
  .search {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid var(--brand-primary-color);
  }
</style>
